import { FC } from 'react'
import { Discount } from '@components/icons'
import { useUI } from '@components/ui/context'
import s from './DiscountButton.module.scss'

const DiscountButton: FC = () => {
  const { toggleDiscount } = useUI()

  const handleDiscountButton = () => {
    toggleDiscount()
  }

  const calcItemsCount = () => {
    var checkitemarray = []
    var itemlist = localStorage.getItem('checklistDiscount')
    if (itemlist) {
      var itemarray = itemlist.split('~')
      for (var i = 0; i < itemarray.length; i++) {
        if (itemarray[i].length > 2) {
          checkitemarray.push(itemarray[i])
        }
      }
    }
    return checkitemarray.length
  }
  var itemsCount = calcItemsCount()

  return (
    <div onClick={handleDiscountButton} className={s['btn-wrap']} title="Discount">
      <div className={s.btn}>
        <div className={s['cart-count-wrapper']}>
          <Discount />
          {itemsCount > 0 && (
            <span
              className={`${s['cart-count']} ${
                itemsCount > 99 ? ['cart-count-above-hundred'] : ''
              }`}
            >
              {itemsCount}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default DiscountButton
